import { Component, Input, EventEmitter, Output, OnInit,ViewChild,Inject, LOCALE_ID } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';
import { SharedDataProvider } from '../../providers/shared-data/shared-data';
import { TranslateService } from '@ngx-translate/core';
import { PrivacyPolicyPage } from '../privacy-policy/privacy-policy';
import { TermServicesPage } from '../term-services/term-services';
import { RefundPolicyPage } from '../refund-policy/refund-policy';
import { SingleSurveyPage } from '../survey/survey';
import { CreateTechSurveyPage } from '../create-tech-survey/create-tech-survey';
import { ConfigProvider } from '../../providers/config/config';
import { LoadingProvider } from '../../providers/loading/loading';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { CartPage } from '../cart/cart';
import { LeadDetailPage } from '../lead-detail-page/lead-detail-page';
import { SearchPage } from '../search/search';
import swal from 'sweetalert';
import { AlertProvider } from '../../providers/alert/alert';
import { HomePage } from '../home/home';
//import * as Survey from 'survey-angular';
import { Http } from '@angular/http';
import { Geolocation } from '@ionic-native/geolocation';
import { CalendarComponent } from "ionic2-calendar/calendar";


@Component({
  selector: 'appointment-page',
  templateUrl: 'appointment-page.html',
})
export class AppointmentPage {
  @ViewChild(CalendarComponent, null) myCal:CalendarComponent;
  errorMessage = '';

  appointments: { [k: string]: any } = {};

    event = {
     title: '',
     desc: '',
     startTime: '',
     endTime: '',
     allDay: false
   };

   minDate = new Date().toISOString();

   eventSource = [];
   viewTitle;

   calendar = {
     mode: 'month',
     currentDate: new Date(),
   };


  constructor(
    public navCtrl: NavController,
    public shared: SharedDataProvider,
    public modalCtrl: ModalController,
    public config: ConfigProvider,
    public navParams: NavParams,
    public loading: LoadingProvider,
    public iab: InAppBrowser,
    translate: TranslateService,
    public http: Http,
    private geolocation: Geolocation,
    public alert: AlertProvider
  ) {
  }


getAppointments(){
  var data: { [k: string]: any } = {};
  data.calendar_id = this.shared.customerData.ghl_calendar_id;;
  data.ghl_token = this.shared.customerData.ghl_token;
  this.loading.show();
  this.http.post(this.config.url + 'getAllAppointmentsforCalendar', data).map(res => res.json()).subscribe(data => {

    if (data.success == 1) {
      this.loading.hide();
      console.log("Got Appointments:",data);

      this.appointments = data;
      this.appointments.appointments.appointments.forEach(function(value, key) {

          var startDate = new Date(value.startTime.replace(/\s/g, "T"));
          var endDate =new Date(value.endTime.replace(/\s/g, "T"));
          var event = {
             title: value.title,
             desc: 'Test Desc',
             startTime: startDate,
             endTime: endDate,
             allDay: false
           };

          this.eventSource.push(event);
        //  this.myCal.loadEvents();

      }.bind(this));


      }
    });

}


ngOnInit() {
  this.getAppointments();
}


ionViewWillEnter() {

}


// Change between month/week/day
changeMode(mode) {
 this.calendar.mode = mode;
}

// Focus today
today() {
 this.calendar.currentDate = new Date();
}

// Selected date reange and hence title changed
onViewTitleChanged(title) {
 this.viewTitle = title;
}

// Calendar event was clicked
async onEventSelected(event) {

  console.log("Selected Event:",event);
  // Use Angular date pipe for conversion
  //let start = formatDate(event.startTime, 'medium', this.locale);
  //let end = formatDate(event.endTime, 'medium', this.locale);

  //const alert = await this.alert.create({
  //  header: event.title,
//    subHeader: event.desc,
//    message: 'From: ' + event.startTime + '<br><br>To: ' + event.endTime,
//    buttons: ['OK']
//  });
//  alert.present();
}


}



// WEBPACK FOOTER //
// ./src/pages/appointment-page/appointment-page.ts